import { createContext, useContext } from 'react';
import { KEYS } from '../../../../l18n/constants';
import appConstants from '../../../../constants';
import { useL18nContext } from '../L18n';
import useNotifications from '../../../../hooks/ui/useNotifications';

const NotificationsContext = createContext();

export function useNotificationsContext() {
  const context = useContext(NotificationsContext);
  if (!context) {
    console.error('useNotificationsContext: the component from which you are trying to use this context must be a ContextProviderNotifications component descendant.');
  }
  return context;
}

export default function ContextProviderNotifications({children}) {
  const { notificationList, notify, dismissNotification } = useNotifications();

  const { getTranslationFor } = useL18nContext();
  const translatedMessageLoginRequired = getTranslationFor(KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED);
  const translatedCaptionMustLogin = getTranslationFor(KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION);
  const translatedLoginLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_LOG_IN);
  const translatedMessageSearchRestorationFailed = getTranslationFor(KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED);
  const translatedMessagePartnerSavedSuccessfully = getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED);
  const translatedMessagePartnerRemovedSuccessfully = getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED);
  const translatedMessagePartnerSavedFailed = getTranslationFor(KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED);
  const translatedMessagePartnerRemovedFailed = getTranslationFor(KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED);
  const translatedDismissControlTitle = getTranslationFor(KEYS.L18N_KEY_LABEL_DISMISS_VERB);

  function loginFn() {
    //const loginURL = `${appConstants.SSO_LOGIN_URL}${encodeURI(window.location.href)}`;
    window.location = appConstants.SSO_LOGIN_URL;
  }

  function notifyMustLogInFn(actionFn = loginFn) {
    notify(
      translatedMessageLoginRequired,
      appConstants.NOTIFICATION_TYPE_INFO,
      true,
      translatedCaptionMustLogin,
      translatedLoginLabel,
      actionFn,
      undefined,
      appConstants.DELAY_MILLISECONDS_5000,
      translatedDismissControlTitle
    );
  }

  function notifyErrorSearchRestorationFn() {
    notify(
      translatedMessageSearchRestorationFailed,
      appConstants.NOTIFICATION_TYPE_ALERT,
      true,
      null,
      null,
      null,
      undefined,
      appConstants.DELAY_MILLISECONDS_5000,
      translatedDismissControlTitle
    );
  }

  function notifySuccessfulUserPartnerSavingFn() {
    notify(
      translatedMessagePartnerSavedSuccessfully,
      appConstants.NOTIFICATION_TYPE_SUCCESS,
      true,
      null,
      null,
      null,
      undefined,
      appConstants.DELAY_MILLISECONDS_5000,
      translatedDismissControlTitle
    );
  }
  function notifyFailedUserPartnerSavingFn(message) {
    notify(
      translatedMessagePartnerSavedFailed,
      appConstants.NOTIFICATION_TYPE_ALERT,
      true,
      message,
      null,
      null,
      undefined,
      appConstants.DELAY_MILLISECONDS_5000,
      translatedDismissControlTitle
    );
  }

  function notifySuccessfulUserPartnerDeletionFn() {
    notify(
      translatedMessagePartnerRemovedSuccessfully,
      appConstants.NOTIFICATION_TYPE_SUCCESS,
      true,
      null,
      null,
      null,
      undefined,
      appConstants.DELAY_MILLISECONDS_5000,
      translatedDismissControlTitle
    );
  }
  function notifyFailedUserPartnerDeletionFn(message) {
    notify(
      translatedMessagePartnerRemovedFailed,
      appConstants.NOTIFICATION_TYPE_ALERT,
      true,
      message,
      null,
      null,
      undefined,
      appConstants.DELAY_MILLISECONDS_5000,
      translatedDismissControlTitle
    );
  }

  return (
    <NotificationsContext.Provider value={
      {
        notificationList,
        notifyMustLogInFn,
        notifyErrorSearchRestorationFn,
        notifySuccessfulUserPartnerSavingFn,
        notifyFailedUserPartnerSavingFn,
        notifySuccessfulUserPartnerDeletionFn,
        notifyFailedUserPartnerDeletionFn,
        dismissNotification
      }
    }>{children}</NotificationsContext.Provider>
  );
}
